import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { ProjectStatusesQuery as ProjectStatusesQueryType } from "./__generated__/ProjectStatusesQuery";

const ProjectStatusesQuery = loader("./ProjectStatusesQuery.gql");

type ProjectStatusesQueryProviderType = (props: {
  children: (data: ProjectStatusesQueryType) => ReactNode;
}) => ReactElement;

export const ProjectStatusesQueryProvider: ProjectStatusesQueryProviderType = (props) => {
  const { children } = props;

  const { error, loading, data } = useQuery<ProjectStatusesQueryType>(ProjectStatusesQuery, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
